import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { MasonryStatusBannerRenderer } from '@leagueplatform/masonry-renderers';
import { useLocation } from '@leagueplatform/routing';
import { useEffect } from 'react';

type MasonryStatusBannerRendererProps = React.ComponentProps<
  typeof MasonryStatusBannerRenderer
>;

export type MasonryStatusBannerNode = MasonryEngineNode<
  'switchRegionStatusBanner',
  MasonryStatusBannerRendererProps
>;

export type StatusBannerWithModalProps =
  MasonryEngineNodeRendererProps<MasonryStatusBannerNode>;

export const StatusBannerWithModal = ({
  ...props
}: MasonryStatusBannerRendererProps) => {
  const location = useLocation();
  const { onFooterClick, ...rest } = props;

  useEffect(() => {
    if (onFooterClick) {
      onFooterClick.payload.url = location.pathname + onFooterClick.payload.url;
    }
  }, [location.pathname, onFooterClick]);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <MasonryStatusBannerRenderer {...rest} onFooterClick={onFooterClick} />
  );
};
